import React, { Component } from "react";
import { View, TouchableHighlight, StyleSheet } from "react-native";
import { connect } from "react-redux";
import AreaListItem from "../components/AreaListItem";
import { FlatList } from "react-native-gesture-handler";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import { faPlus, faSyncAlt } from "../../assets/consts/faCharCodes";
import * as Actions from "../actions/AreaActions";
import * as AreaHelper from "../actions/AreaHelper";
import Theme from "../argon-ui/Theme";
import Loading from "../components/Loading";
import MessageBox from "../components_v2/MessageBox";
import { translate } from "../locales/translate";

class AreaListScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      areasCount: this.props.reducer.areasCount,
      accessToken: "",
      isLoading: false,
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.AreasList"),
  });
  componentDidMount() {
    this.setState({
      accessToken: this.props.appReducer.currentServer.accessToken,
    });
  }
  componentDidUpdate() {
    if (this.props.reducer.areasCount != this.state.areasCount) {
      this.setState({ areasCount: this.props.reducer.areasCount });
    }

    if (this.props.reducer.isModified) {
      this.props.refresh(
        this.state.accessToken,
        this.props.appReducer.currentBuilding.buildingId
      );
      this.props.getAll(
        this.state.accessToken,
        this.props.appReducer.currentBuilding.buildingId
      );
    }
  }

  onRefreshButtonPress = () => {
    this.setState({ isLoading: true });
    this.props.clearAll();
    this.props.getAll(
      this.state.accessToken,
      this.props.appReducer.currentBuilding.buildingId
    );
    setTimeout(() => {
      this.setState({ isLoading: false });
      //this.setState({ isLoading: false });
    }, 3000);
  };

  render() {
    if (this.state.isLoading) return <Loading />;

    var list = [];
    const rootIds = [];
    const { areas } = this.props.reducer;
    areas.map((ar) => {
      if (
        !ar.parentAreaId ||
        (ar.parentAreaUId !== null &&
          ar.parentAreaUId !== undefined &&
          !ar.parentAreaUId)
      ) {
        list.push(ar);
        rootIds.push(ar.areaId || ar.areaUId);
      }
    });

    for (var i in areas) {
      const area = areas[i];
      if (area.parentAreaId || area.parentAreaUId) {
        var mp = AreaHelper.findMainParent(areas, area);
        var _areaId = mp.areaId || mp.areaUId;
        if (mp && rootIds.indexOf(_areaId) < 0) {
          list.push(area);
          rootIds.push(area.areaId || area.areaUId);
        }
      }
    }
    return (
      <View style={{ flex: 1, paddingHorizontal: 10 }}>
        {list.length == 0 ? (
          <View style={{ paddingHorizontal: 10 }}>
            <MessageBox>{translate("app.noAreaAccessYet")}</MessageBox>
          </View>
        ) : (
          <FlatList
            data={list}
            keyExtractor={(item, i) => item.areaId.toString()}
            renderItem={({ item }) => (
              <AreaListItem
                model={item}
                allAreas={this.props.reducer.areas}
                key={item.areaId.toString()}
                navigator={this.props.navigation}
                style={{ marginBottom: 10 }}
              />
            )}
          />
        )}
        {areas.some(
          (a) => a.accessLevel == "Admin" || a.accessLevel == "Support"
        ) && (
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TouchableHighlight
              style={style.btnAdd}
              onPress={() => this.props.navigation.navigate("AreaForm")}
            >
              <FontAwesomeIcon icon={faPlus} size={30} color="#FFF" />
            </TouchableHighlight>
            <TouchableHighlight
              style={style.btnRefresh}
              onPress={this.onRefreshButtonPress}
            >
              <FontAwesomeIcon icon={faSyncAlt} size={15} color="#FFF" />
            </TouchableHighlight>
          </View>
        )}
      </View>
    );
  }
}

const style = StyleSheet.create({
  btnAdd: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: Theme.COLORS.PRIMARY,
    //position: "absolute",
    marginHorizontal: 15,
    bottom: 15,
    shadowColor: "#000",
    shadowRadius: 5,
    elevation: 10,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  btnRefresh: {
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: Theme.COLORS.TL_PURPLE,
    //position: "absolute",
    bottom: 5,
    // marginEnd: -30,
    shadowColor: "#000",
    shadowRadius: 5,
    elevation: 10,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.AreaReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    refresh: (accessToken, buildingId) =>
      dispatch(Actions.Refresh(accessToken, buildingId)),
    getAll: (accessToken, buildingId) =>
      dispatch(Actions.GetAll(accessToken, buildingId)),
    clearAll: () => dispatch(Actions.ClearAll()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AreaListScreen);
